import { render, staticRenderFns } from "./CedisPerformance.vue?vue&type=template&id=5f2fad28"
import script from "./CedisPerformance.vue?vue&type=script&lang=js"
export * from "./CedisPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports